module.exports = __webpack_public_path__ + "img/wx_pay_ts.ba617aa7.png";